import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class EmptyPathRedirectGuard implements CanActivate {
  private _userService = inject(UserService);
  router = inject(Router);

  async canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const user = await this._userService.isLogged();
    if (user) {
      if (state.url === '/') {
        this._userService.redirectUser(user);
        return false;
      } else {
        return true;
      }
    } else {
      return this.router.navigate(['/login']);
    }
  }

  canActivateChild(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    return this.canActivate(null, null);
  }
}
